import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 215  -  字符串
 */

export default class EventString extends EventBase {
  private static normalizeParameter(param?: string[]) {
    const next = [...(param ?? ['0', '', '0', '-1,0'])]
    while (next.length < 4) {
      next.push(next.length === 3 ? '-1,0' : '')
    }
    return next
  }
  /**
   * 构造函数
   */
  constructor(param?: string[]) {
    super()
    this.Parameter = EventString.normalizeParameter(param)
  }

  // #region 事件内主要属性参数
  /**
   * 字符串索引
   */
  get Index() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Index(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 设置支持多语言的数组
   * @param indexes 
   */
  setLocalesParam(indexes: number[]): void {
    indexes = [1]
    super.setLocalesParam(indexes)
  }

  /**
   * 字符串内容
   */
  get Content() {
    return this.Parameter?.[1] ?? ''
  }
  set Content(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 是否按变量索引取字符串编号
   */
  get IsVarIndex() {
    return this.Parameter?.[2] === '1'
  }
  set IsVarIndex(value) {
    this.Parameter![2] = value ? '1' : '0'
  }

  /**
   * 索引的整合变量信息
   */
  get keyUnitInfo() {
    return this.Parameter?.[3] ?? '-1,0'
  }
  set keyUnitInfo(value) {
    this.Parameter![3] = value?.toString() || '-1,0'
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.String
}
